/* generated by pull.js */
const manifest = {
    "name": "Newgrounds Audio Import",
    "description": "Import audio directly from Newgrounds into the sound editor.",
    "credits": [
        {
            "name": "SharkPool",
            "link": "https://github.com/SharkPool-SP/"
        }
    ],
    "info": [
      {
        "type": "notice",
        "text": "Some audio on Newgrounds may not be licensed for public or commercial use. This addon will try to warn you or block downloads when restrictions apply.",
        "id": "copyright-notice"
      }
    ],
    "userscripts": [
        {
            "url": "userscript.js"
        }
    ],
    "tags": ["editor", "new"],
    "enabledByDefault": false,
    "dynamicEnable": true,
    "dynamicDisable": false
};
export default manifest;